import {
	isArray,
	isNil
} from 'lodash';

export function forceArray(p: any): any[] {
	return isArray(p) ? p : (isNil(p) ? [] : [p])
}
